var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.loading)?_c('b-badge',{attrs:{"variant":"danger"}},[_c('img',{staticStyle:{"width":"10px"},attrs:{"src":"/img/loading2.svg","alt":"Loading"}})]):_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v(" "+_vm._s(_vm.count)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }